export default __webpack_public_path__ + "static/media/icon-evmos.d1853d79.png";